import styled from 'styled-components';

export const Container = styled.div`
.deleteIcon{
    cursor: pointer;
}
`;